<template>
    <div v-if="usersActivity" class="avatars-activity" :class="orientation">
        <div class="avatars">
            <div v-for="user in usersActivity" :key="user.initials" class="initials-icon" :style="{'background-color': user.color ? user.color : ''  }">
                {{ user.initials || 'A' }}
            </div>   
        </div> 
        <div class="text" :class="[{'one': usersActivity.length == 1},orientation]" >
            <p v-for="activity in usersActivity" :key="activity.title">
                {{ activity.title }} 
                <span :class="{'block': activity.twoLines}">{{ activity.personName }}  </span> 
                <template v-if="activity.date">
                    On <span>{{ activity.date }}</span>
                </template>
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue'; 

export interface usersActivityInterface {
    title: string,
    date?: string,
    personName: string, 
    initials: string,
    color?: string,
    twoLines?: boolean
}

defineProps<{ usersActivity: usersActivityInterface[], orientation: string }>();

</script>

<style lang="scss" scoped>
.avatars-activity {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 2rem; 
    justify-content: flex-start;
    &.right {
        justify-content: flex-start;
        flex-direction: row-reverse;
        .initials-icon{
            &:first-child {    
                right: -0.7rem;
                position: relative;
                margin-right: 0;
                margin-left: 0.5rem;
            }
        }   
    }
    &.left {
        .initials-icon {
            &:nth-child(2) {
                position: relative;
                left: -1.1rem;
                margin-right: 0.5rem;
            }
        }
    }
    .avatars {
        display: flex;
        .initials-icon {
            border: 3px solid #eee;
            font-size: 14px;
            padding-top: 11px;
            &:first-child { background-color: #003F8A; }
            &:nth-child(2) { background-color: #7D91BC; }
        }
    }
    .text {
        font-size: 0.8rem;
        padding-right: 0.5rem;
        font-weight: 300;
        color: $font-color-light;
        span { font-weight: 500; color: $font-color-light}
        &.left {
            position: relative;
            left: -1.3rem;
            &.one {
                left: -0.3rem;
            }
        }
        &.right {
            text-align: right;
            position: relative;
            right: -1.3rem;
        }
    }
}
.activity-item {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 0.5rem;
            &:first-child {
                .initials-icon{ background-color: #008E91;} 
            }
            &:nth-child(2) {
                .initials-icon{ background-color: #557B97;} 
            }
            p { font-size: 0.8rem; }
            .initials-icon{margin-right: 0; }
            
        }
    
</style>
